import ApiService from "./api_service";
export default {
    async get(page, params) {
        return await ApiService.call('get', 'users/?page=' + page + '&' + params);
    },
    async get_all(params) {
        return await ApiService.call('get', 'users/all/?' + params);
    },
    async get_detail(user_id) {
        return await ApiService.call('get', 'users/' + user_id + '/');
    },
    async post(payload) {
        return await ApiService.call('post', 'users/register/', payload);
    },
    async patch(user_id, payload) {
        return await ApiService.call('patch', 'users/' + user_id + '/', payload);
    },
    async delete(user_id) {
        return await ApiService.call('delete', 'users/' + user_id + '/');
    },
    async get_me() {
        return await ApiService.call('get', 'users/me/');
    },
    async request_password_reset(payload) {
        return await ApiService.call('post', 'request-password-reset/', payload);
    },
    async reset_password(code, payload) {
        return await ApiService.call('put', 'reset-password/' + code + '/', payload);
    },
}